<script setup lang="ts">
import {useActors, useSettings} from '../../compositions';
const { coverImgSrc, logoImgSrc } = useSettings();
const { merchant } = useActors();
</script>

<template>
    <template v-if="coverImgSrc">
        <div class="position-relative">
            <div
                v-if="coverImgSrc"
                class="position-relative"
                style="width: 100%; height: 10.25rem; background-size: cover; background-position: center;"
                :style="{ backgroundImage: `url('${coverImgSrc}')` }"/>
            <div class="d-flex gap-16 justify-content-start business-name-padding">
                <span class="hb24 text-midnight-800" v-text="merchant.businessName"/>
            </div>
            <div
                v-if="logoImgSrc"
                class="position-absolute logo-style"
                style="left: 1rem; bottom: 1.5rem;"
                :style="{ backgroundImage: `url('${logoImgSrc}')` }"/>
        </div>
    </template>
    <template v-else>
        <div class="d-flex flex-column gap-8 align-items-center justify-content-center py-24">
            <div
                v-if="logoImgSrc"
                class="logo-style"
                :style="{ backgroundImage: `url('${logoImgSrc}')` }"/>
            <span class="hb24 text-midnight-800" v-text="merchant.businessName"/>
        </div>
    </template>
</template>

<style scoped lang="scss">
.business-name-padding {
    padding: 1rem 1rem 1rem 8.5rem;
    span {
        min-height: 4rem;
    }
}

.logo-style {
    left: 1rem;
    bottom: 1.5rem;
    width: 6.5rem;
    height: 6.5rem;
    aspect-ratio: 1 / 1;
    background-size: cover;
    background-position: center;
    border-radius: 50%
}
</style>